import type { DayOfWeek } from '../../../common/enum/dayOfWeek';

export type TimeRange = {
  start: string;
  end: string;
};

export type DayOfWeekOpening = {
  days: Partial<Record<DayOfWeek, Opening>>;
};

export enum OpeningHoursType {
  WEEKLY = 'weekly',
  DAILY = 'daily',
}

export const NOT_APPLICABLE_OPENING_HOURS_TYPE = 'na';

export type Opening =
  | {
      isAllDay: true;
    }
  | { isAllDay: false; slots: TimeRange[] };

export type OpeningHours =
  | ({ type: OpeningHoursType.WEEKLY } & Opening)
  | ({ type: OpeningHoursType.DAILY } & DayOfWeekOpening);
